import { Box, Button, CircularProgress, selectClasses, Tooltip, tooltipClasses, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { GlobalState } from "context/GlobalContext";
import { converAttrToDatagridCol } from "data/globalData";
import { Fragment, useEffect, useState } from "react";
import { channelTypes } from "components/PimDashboard/DashboardComponents/Buying/BuyingSheet/data";
import styled from "@emotion/styled";
import { roundDecimalValueUptoTwo } from "utils/RoundDecimalValue";
import { grey, orange } from "@mui/material/colors";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";
import axios from "axios";

const allSizes = ["S", "M", "L", "XL", "XXL", "XXXL"];

const HtmlTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)(({ theme }) => ({
	[`& .${tooltipClasses.tooltip}`]: {
		// backgroundColor: "#f5f5f9",
		backgroundColor: "white",
		color: "rgba(0, 0, 0, 0.87)",
		maxWidth: 400,
		fontSize: theme.typography.pxToRem(12),
		border: "1px solid #dadde9",
	},
}));
const RenderSizeQtyData = ({ column, data }) => {
	const qtyPercent =
		data["total"] > 0 && data[column] > 0 ? Math.floor(roundDecimalValueUptoTwo((data[column] / data["total"]) * 100)) : 0;

	return (
		<Box width="100%" height="100%" display="flex" alignItems="center" justifyContent="space-around">
			<Tooltip title={"Size Ratio"} arrow>
				<span style={{ width: "25%", color: orange[900] }}>{qtyPercent}%</span>
			</Tooltip>
			<HtmlTooltip title={"QTY"}>
				<Typography variant="body2" fontWeight={600}>
					{data[column] ?? 0}
				</Typography>
			</HtmlTooltip>
		</Box>
	);
};

const HistoricalSizeRatioDataTable = ({
	data,
	dataLoading,
	handleActionClick = () => {},
	selectedChannel,
	selectedRegion,
	manualTotalQty,
}) => {
	const { setSnackBar, snackBar, setSnackBarOpen } = GlobalState();
	console.log(manualTotalQty, "manualTotalQty");
	const [tableRows, setTableRows] = useState();
	const [tableColumns, setTableColumns] = useState([]);

	const tableColumnsasd = [
		converAttrToDatagridCol({ name: "MRP", key: "mrp" }),
		...allSizes.map((row) => {
			return {
				...converAttrToDatagridCol({ name: row, key: row }),
				renderCell: ({ field, row }) => {
					let value = 20;
					if (field === "S") value = 20;
					if (field === "M") value = 30;
					if (field === "L") value = 30;
					if (field === "XL") value = 10;
					if (field === "XXL") value = 10;
					return <RenderSizeQtyData column={field} data={{ ...row, [field]: `${value}%` }} />;
				},
			};
		}),
		{
			...converAttrToDatagridCol({ name: "TOTAL", key: `TOTAL` }),
			renderCell: ({ field, row }) => {
				return <RenderSizeQtyData column={field} data={row} />;
			},
		},
		{
			...converAttrToDatagridCol({ name: "Action", key: `action` }),
			renderCell: ({ field, row }) => {
				// if (selectedTab === tabsList.size_ratio.key)
				return (
					<Button variant="contained" onClick={() => handleActionClick(row)}>
						Use
					</Button>
				);
				// else return <></>;
			},
		},
	];

	useEffect(() => {
		if (data && !dataLoading) {
			const filteredData = data?.filter((row) => row.REGION === selectedRegion && row.CHANNEL === selectedChannel);
			const distinctMrp = [...new Set(filteredData?.map((row) => row.MRP))];
			const distinctSizes = [...new Set(filteredData?.map((row) => row.SIZE))];

			let id = 1;
			setTableRows(
				distinctMrp?.map((mrp) => {
					const sizes = [...new Set(filteredData?.filter((row) => row.MRP === mrp)?.map((row) => row.SIZE))];

					let obj = {
						mrp,
						distinct_sizes: sizes,
						id: id++,
					};
					let total = 0;
					filteredData
						?.filter((row) => row?.MRP === mrp)
						?.forEach((row) => {
							obj[row.SIZE] = Number(row.QTY) ? Number(row.QTY) : 0;
							total += +row.QTY;
						});
					obj["total"] = total;
					return obj;
				})
			);
			setTableColumns([
				converAttrToDatagridCol({ name: "MRP", key: "mrp" }),
				...distinctSizes.sort().map((row) => {
					return {
						...converAttrToDatagridCol({ name: row, key: row }),

						renderCell: ({ field, row }) => {
							// console.log(field, row, "sajdkasdjn");

							return <RenderSizeQtyData column={field} data={row} />;
						},
					};
				}),
				{
					...converAttrToDatagridCol({ name: "TOTAL", key: `total` }),
					renderCell: ({ field, row }) => {
						return <RenderSizeQtyData column={field} data={row} />;
					},
				},
			]);
		}
	}, [data, selectedChannel, selectedRegion]);

	return (
		<Box width="100%">
			{dataLoading ? (
				<Box width="100%" height={130} display="flex" justifyContent="center" alignItems="center">
					<CircularProgress />
				</Box>
			) : (
				<Box>
					<DataGrid
						rows={tableRows ?? []}
						columns={[
							...tableColumns,
							{
								...converAttrToDatagridCol({ name: "Action", key: `action` }),
								renderCell: ({ field, row }) => {
									// if (selectedTab === tabsList.size_ratio.key)
									return (
										<Button variant="contained" onClick={() => handleActionClick(row, manualTotalQty?.qty)}>
											Use
										</Button>
									);
									// else return <></>;
								},
							},
						]}
						hideFooter
						sx={{
							height: 130,
							border: `1px solid ${grey[300]}`,
							"& .MuiDataGrid-row": {
								// borderBottom: "1px solid lightgray",
								// cursor: "pointer",
								border: "none",
							},
							"& .MuiDataGrid-cell": {
								// borderBottom: "1px solid lightgray",
								// cursor: "pointer",
								borderRight: `1px solid ${grey[300]}`,
							},
							"& .MuiDataGrid-columnHeader": {
								cursor: "pointer",
								borderRight: `1px solid ${grey[300]}`,
							},
							"& .MuiDataGrid-columnHeaders": {
								background: grey[300],
								// mb: 2,
								border: "none",
								borderRadius: 1,
								// padding: "10px 0px",
							},
							"& .MuiDataGrid-cell": {
								padding: "2px",
								borderRight: `1px solid ${grey[200]}`,
							},
							"& .MuiDataGrid-row:hover": {
								backgroundColor: "inherit", // Or 'transparent' or whatever color you'd like
							},
						}}
						columnHeaderHeight={35}
						rowHeight={30}
						disableRowSelectionOnClick
					/>
				</Box>
			)}
		</Box>
	);
};

export default HistoricalSizeRatioDataTable;
